module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/placeholder/placeholder-05-61565f2c552818479154cb6bdb4590be.jpg";